export const environment = {
  production: true,
  consentMgrUrl: "https://cdn.consentmanager.net/delivery/autoblocking/a8da0a0601ee0.js"
};
